import { render, staticRenderFns } from "./PersonalAntecedentsToOptometry.vue?vue&type=template&id=23f4acfa&"
import script from "./PersonalAntecedentsToOptometry.vue?vue&type=script&lang=js&"
export * from "./PersonalAntecedentsToOptometry.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAntecedentsToOptometry.vue?vue&type=style&index=0&id=23f4acfa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports